import { render, staticRenderFns } from "./cierre.vue?vue&type=template&id=489ca52a"
import script from "./cierre.vue?vue&type=script&lang=js"
export * from "./cierre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports